module.exports = __webpack_public_path__ + "static/img/stay-option-icon-towel.9505900c.svg";